import { useHandlerQuery } from '../../useHandlerQuery';

export const useGetContacts = () =>
  useHandlerQuery((api) => api.contact().getContacts(), {
    key: ['CONTACTS'],
  });
